import { render, staticRenderFns } from "./SosModalBottomSheet.vue?vue&type=template&id=12e7f170"
import script from "./SosModalBottomSheet.vue?vue&type=script&lang=js"
export * from "./SosModalBottomSheet.vue?vue&type=script&lang=js"
import style0 from "./SosModalBottomSheet.vue?vue&type=style&index=0&id=12e7f170&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports